import Prompt, { PromptRating, PromptStatus } from "@/models/prompt/prompt";
import {
  crudService,
  CrudServiceType,
  handlePaginationQuery,
} from "./crudService";
import { RestClient } from "./restClient";
import RestResponse from "@/models/client/RestResponse";
import RequestMethod from "@/models/client/RequestMethod";
import { Pagination, PaginationQuery } from "@/models/base/Pagination";

export type PromptServiceType = CrudServiceType<Prompt> & {
  // extra methods here
  getMyPrompts: (
    query: PaginationQuery,
    signal?: AbortSignal
  ) => RestResponse<Pagination<Prompt>>;
  updatePromptStatus: (
    id: string,
    status: PromptStatus
  ) => RestResponse<string>;
  usePrompt: (id: string) => RestResponse<string>;
  ratePrompt: (id: string, rating: PromptRating) => RestResponse<string>;
  favoritePrompt: (id: string) => RestResponse<string>;
  deletePrompt: (id: string) => RestResponse<string>;
};

const promptServices = (
  client: RestClient,
  path: string
): PromptServiceType => ({
  ...crudService<Prompt>(client, path),
  getMyPrompts: async (query: PaginationQuery, signal?: AbortSignal) =>
    await client.fetch<Pagination<Prompt>>(
      RequestMethod.GET,
      `${path}/me?${handlePaginationQuery(query)}`,
      undefined,
      undefined,
      undefined,
      undefined,
      { signal }
    ),
  updatePromptStatus: async (id: string, status: PromptStatus) =>
    await client.fetch<string>(
      RequestMethod.PUT,
      `${path}/${id}/update-status`,
      {
        status: status,
      }
    ),
  usePrompt: async (id: string) =>
    await client.fetch<string>(RequestMethod.PUT, `${path}/${id}/use`),
  ratePrompt: async (id: string, rating: PromptRating) =>
    await client.fetch<string>(RequestMethod.PUT, `${path}/${id}/rate`, {
      rating: rating,
    }),
  favoritePrompt: async (id: string) =>
    await client.fetch<string>(RequestMethod.PUT, `${path}/${id}/favorite`),
  deletePrompt: async (id: string) =>
    await client.fetch<string>(RequestMethod.DELETE, `${path}/${id}`),
});

export default promptServices;
